(function ($) {
  DJ.addBehavior('hpSlider', '.hp-slider', {
    attach: function (context, settings) {
      const $hpSlider = $(this);

      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

      $hpSlider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        speed: 500,
        fade: true,
        adaptiveHeight: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 5000,
      });
    },
    detach: function (context, settings) {}
  });
})(jQuery);
